document.addEventListener("DOMContentLoaded", function () {
  const thumbnails = document.querySelectorAll(".product-single__thumbnail");
  const images = document.querySelectorAll(".product-single__photo");
  thumbnails.forEach((thumb) => {
    thumb.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("data-thumbnail-id");
      images.forEach((img) => {
        img.classList.add("hide");
      });
      const activeImage = document.querySelector(
        `.product-single__photo[data-image-id="${targetId}"]`
      );
      if (activeImage) {
        activeImage.classList.remove("hide");
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const selects = document.querySelectorAll('.single-option-selector');
  const variantSelect = document.querySelector('[name="id"]');
  if (variantSelect) {
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }
  selects.forEach(select => {
    const placeholder = select.querySelector('[data-placeholder]');
    if (!placeholder) return;
    const realValue = select.value;
    setTimeout(() => {
      select.dataset.realValue = realValue;
      select.options[0].selected = true; 
    }, 100);
    select.addEventListener('change', function () {
      if (select.value !== "") {
        select.dataset.realValue = select.value;
      }
    });
    select.addEventListener('focus', function () {
      if (select.dataset.realValue) {
        select.value = select.dataset.realValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.querySelector('[name="add"]');
  const form = document.querySelector("form");
  const onRadio = document.querySelector(".on_personalization");
  const offRadio = document.querySelector(".of_Personalization");
  const wrapper = document.querySelector(".product-personatt88");
  const nameInput = document.getElementById("personalization-text");
  const fontSelect = document.getElementById("font-real-select");
  const threadSelect = document.getElementById("real-select");
  const nameError = document.getElementById("personalization-error");
  const fontError = document.getElementById("font-error");
  const threadError = document.getElementById("thread-error");
  const variantSelects = document.querySelectorAll('.single-option-selector');
  const threadContainer = document.getElementById('dropdown-container');
  const threadSelected = document.getElementById('selected-option');
  const threadOptionsBox = document.getElementById('dropdown-options');
  const fontContainer = document.getElementById("font-dropdown-container");
  const fontSelected = document.getElementById("font-selected-option");
  const fontOptionsBox = document.getElementById("font-dropdown-options");
  const noMessage = document.querySelector(".show_mssge");

  function isPersonalizationOff() {
    return offRadio && offRadio.checked;
  }

  function enableFields() {
    if (wrapper) { wrapper.style.display = "block"; } 
    nameInput?.setAttribute("required", "required");
    fontSelect?.setAttribute("required", "required");
    threadSelect?.setAttribute("required", "required");
  }

  function disableFields() {
    if (wrapper) { wrapper.style.display = "none"; } 
    nameInput?.removeAttribute("required");
    fontSelect?.removeAttribute("required");
    threadSelect?.removeAttribute("required");
    if (nameInput) nameInput.value = "";
    if (fontSelect) fontSelect.value = "";
    if (threadSelect) threadSelect.value = "";
    nameError?.classList.remove("show");
    if (fontError) fontError.style.display = "none";
    if (threadError) threadError.style.display = "none";
  }

  function toggleFields() {
    if (isPersonalizationOff()) {
      disableFields();
      if (noMessage) noMessage.style.display = "block";
    } else {
      enableFields();
      if (noMessage) noMessage.style.display = "none";
    }
  }

  onRadio?.addEventListener("change", toggleFields);
  offRadio?.addEventListener("change", toggleFields);
  toggleFields();

  variantSelects.forEach(select => {
    const errorMsg = select.parentElement.querySelector('.variant-error');
    select.addEventListener("change", function () {
      if (this.value) {
        errorMsg && (errorMsg.style.display = "none");
      }
    });
    if (select.value) {
      errorMsg && (errorMsg.style.display = "none");
    }
  });

  addToCartBtn?.addEventListener("click", function (e) {
    let hasError = false;
    variantSelects.forEach(select => {
      const errorMsg = select.parentElement.querySelector('.variant-error');
      if (!select.value) {
        e.preventDefault();
        hasError = true;
        errorMsg && (errorMsg.style.display = "block");
        select.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });

    if (!isPersonalizationOff()) {
      if (nameInput && nameInput.value.trim() === "") {
        e.preventDefault();
        nameError?.classList.add("show");
        hasError = true;
      }
      if (fontSelect && !fontSelect.value) {
        e.preventDefault();
        fontError && (fontError.style.display = "block");
        hasError = true;
      }
      if (threadSelect && !threadSelect.value) {
        e.preventDefault();
        threadError && (threadError.style.display = "block");
        hasError = true;
      }
    }

    if (hasError) {
      wrapper?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });

  form?.addEventListener("submit", function () {
    if (isPersonalizationOff()) {
      document
        .querySelectorAll(".product-personatt88 [required]")
        .forEach(el => el.removeAttribute("required"));
    }
  });

  nameInput?.addEventListener("input", function () {
    if (this.value.trim()) {
      nameError?.classList.remove("show");
    }
  });

  threadSelected?.addEventListener("click", function (e) {
    e.stopPropagation();
    threadOptionsBox.style.display =
      threadOptionsBox.style.display === "grid" ? "none" : "grid";
  });

  document.querySelectorAll('.Thread_option').forEach(item => {
    item.addEventListener('click', function () {
      const val = this.dataset.value;
      const img = this.dataset.image;
      threadSelected.innerHTML = `<img src="${img}"><span>${val}</span>`;
      threadSelect.value = val;
      threadError && (threadError.style.display = "none");
      threadOptionsBox.style.display = "none";
    });
  });

  fontSelected?.addEventListener("click", function (e) {
    e.stopPropagation();
    fontContainer.classList.toggle("active");
  });

  document.querySelectorAll('.Tfont_option').forEach(item => {
    item.addEventListener('click', function () {
      const val = this.dataset.value;
      const img = this.dataset.image;
      fontSelected.innerHTML = `<img src="${img}"><span>${val}</span>`;
      fontSelect.value = val;
      fontError && (fontError.style.display = "none");
      fontContainer.classList.remove("active");
    });
  });

  document.addEventListener("click", function () {
    threadOptionsBox && (threadOptionsBox.style.display = "none");
    fontContainer && fontContainer.classList.remove("active");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const onRadio = document.querySelector(".on_personalization");
  const offRadio = document.querySelector(".of_Personalization");
  const personalizationField = document.getElementById("personalization-field");
  
  function updatePersonalizationValue() {
    if (!personalizationField) return;
    personalizationField.setAttribute("name", "properties[_personalization]");
    personalizationField.value = offRadio?.checked ? "No" : "Yes";
    console.log("Personalization:", personalizationField.value);
  }
  
  onRadio?.addEventListener("change", updatePersonalizationValue);
  offRadio?.addEventListener("change", updatePersonalizationValue);
  updatePersonalizationValue();
});

document.addEventListener("DOMContentLoaded", function () {
  const yesRadio = document.querySelector(".on_personalization");
  const noRadio = document.querySelector(".of_Personalization");
  const variantDropdown = document.querySelector(".single-option-selector");
  const colorProperty = document.getElementById("selected-color-property");
  const personalizationField = document.getElementById("personalization-field");
  if (!variantDropdown) return;
  
  let originalVariant = "";
  const hiddenOption = variantDropdown.querySelector('option[value="Without Personalization"]');
  if (hiddenOption) {
    hiddenOption.style.display = "none";
  }
  
  const persLabel = document.createElement("span");
  persLabel.className = "custom-ui-label";
  persLabel.style.cssText = `
    position:absolute;
    left:15px;
    top:20px;
    transform:translateY(-50%);
    pointer-events:none;
    background:#fff;
    display:none;
    z-index:5;
    width:80%;
  `;
  persLabel.textContent = "Select an Option";
  variantDropdown.parentElement.style.position = "relative";
  variantDropdown.parentElement.appendChild(persLabel);
  
  if (variantDropdown.value && variantDropdown.value !== "Without Personalization") {
    originalVariant = variantDropdown.value;
    if (colorProperty) {
      colorProperty.value = originalVariant;
    }
  }
  
  variantDropdown.addEventListener("change", function () {
    if (this.value !== "Without Personalization" && this.value !== "") {
      originalVariant = this.value;
      persLabel.textContent = originalVariant;
      if (colorProperty) {
        colorProperty.value = originalVariant;
      }
      this.dispatchEvent(new Event("input", { bubbles: true }));
    }
    if (noRadio && noRadio.checked) {
      if (this.value !== "Without Personalization") {
        setTimeout(() => {
          this.value = "Without Personalization";
          this.style.color = "transparent";
          persLabel.style.display = "block";
          this.dispatchEvent(new Event("change", { bubbles: true }));
        }, 10);
      }
    }
  });
  
  function updateVariant() {
    if (noRadio.checked) {
      if (personalizationField) {
        personalizationField.value = "No";
      }
      variantDropdown.value = "Without Personalization";
      variantDropdown.style.color = "transparent";
      if (persLabel) {
        persLabel.textContent = "Select an Option";
        persLabel.style.display = "block";
      }
    } else {
      if (personalizationField) {
        personalizationField.value = "Yes";
      }
      variantDropdown.style.color = "";
      if (persLabel) {
        if (originalVariant) {
          persLabel.textContent = originalVariant;
          persLabel.style.display = "block";
        } else {
          persLabel.textContent = "Select an Option";
          persLabel.style.display = "block";
        }
      }
      if (originalVariant) {
        variantDropdown.value = originalVariant;
      } else {
        variantDropdown.selectedIndex = 0;
      }
    }
    variantDropdown.dispatchEvent(new Event("input", { bubbles: true }));
    variantDropdown.dispatchEvent(new Event("change", { bubbles: true }));
  }
  
  const addToCartBtn = document.querySelector('button[name="add"], .add-to-cart');
  const variantError = document.querySelector(".variant-error");
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function (e) {
      if (noRadio.checked && persLabel.textContent === "Select an Option") {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (variantError) {
          variantError.style.display = "block";
          variantError.style.marginTop = "5px";
        }
        variantDropdown.style.border = "1px solid red";
        return false;
      }
    });
  }
  
  variantDropdown.addEventListener("change", function () {
    if (this.value !== "" && this.value !== "Without Personalization" && variantError) {
      variantError.style.display = "none";
      this.style.border = "";
    }
  });
  
  yesRadio?.addEventListener("change", updateVariant);
  noRadio?.addEventListener("change", updateVariant);
});




/////// Quilt Personalized - Final Working Fix /////////////////////////
document.addEventListener("DOMContentLoaded", function () {
  const radios = document.querySelectorAll('input[name="personalization_toggle"]');
  function checkRadioFields() {
    const isNoChecked = document.querySelector('input[name="personalization_toggle"]:checked')?.value === 'off';
    const mainSection = document.querySelector('.product-customized88');
    const hiddenStatusInput = document.getElementById('personalization-field');
    const inputs = document.querySelectorAll('.product-customized88 input:not([name="properties[Quilt Color]"]), .product-customized88 select');
    const babySection = document.querySelector(".prodh-tom-Phrase");
      if (isNoChecked) {
          if (babySection) babySection.style.display = "none";
      } else {
          if (babySection) babySection.style.display = "block";
      }

    if (isNoChecked) {
      if (mainSection) mainSection.style.display = 'none';
      document.querySelectorAll('.quilt-font-error, #st-error-qutt, #style-error-qutt').forEach(el => el.style.display = 'none');
      document.querySelectorAll('.field-error, .quilt-font_select, .quilt-selected-option').forEach(el => el.classList.remove('field-error'));
      inputs.forEach(input => {
        input.disabled = true;
        if (input.type === 'text') input.value = '';
        if (input.tagName.toLowerCase() === 'select') {
          input.value = '';
          input.removeAttribute('required');
        }
      });
      
      document.querySelectorAll('.quilt-font_select span, .quilt-selected-option span').forEach(span => span.textContent = 'Select an Option');
      if (hiddenStatusInput) {
        hiddenStatusInput.setAttribute('name', 'properties[_personalization]');
        hiddenStatusInput.value = 'No';
        hiddenStatusInput.disabled = false; 
      }

    } else {
      if (mainSection) mainSection.style.display = 'block';
      inputs.forEach(input => {
        input.disabled = false;
        if (input.id && input.id.includes('quilt-font-real-select')) {
          input.setAttribute('required', 'required');
        }
      });
      if (hiddenStatusInput) {
        hiddenStatusInput.setAttribute('name', 'properties[Personalization]');
        hiddenStatusInput.value = 'Yes';
        hiddenStatusInput.disabled = false;
      }
    }
  }

  radios.forEach(r => r.addEventListener('change', checkRadioFields));
  checkRadioFields(); 
  document.querySelectorAll(".quilt-dropdown-container").forEach((dropdown) => {
    const selected = dropdown.querySelector(".quilt-selected-option");
    const options = dropdown.querySelectorAll(".quilt_Thread_option");
    const hiddenInput = dropdown.querySelector(".real-select");
    if (!selected || !hiddenInput) return;
    
    selected.addEventListener("click", function (e) {
      e.stopPropagation();
      document.querySelectorAll(".quilt-dropdown-container, [id^='quilt-font-dropdown-container']").forEach((d) => {
        if (d !== dropdown) d.classList.remove("active");
      });
      dropdown.classList.toggle("active");
    });
    
    options.forEach((option) => {
      option.addEventListener("click", function () {
        if (hiddenInput.disabled) return;
        const val = this.dataset.value;
        const img = this.dataset.image;
        hiddenInput.value = val;
        selected.innerHTML = `<div class="selected-thread-item"><img src="${img}" alt="${val}"><span>${val}</span></div>`;
        dropdown.classList.remove("active");
        selected.classList.remove("field-error");
        const wrapper = dropdown.closest(".product-custom-Phrase");
        if (wrapper) {
          const error = wrapper.querySelector(".quilt-font-error");
          if (error) error.style.display = "none";
        }
      });
    });
  });
  document.querySelectorAll("[id^='quilt-font-dropdown-container']").forEach((fontDropdown) => {
    const selected = fontDropdown.querySelector(".quilt-font_select");
    const options = fontDropdown.querySelectorAll(".quilt-Tfont_option");
    const idSuffix = fontDropdown.id.replace("quilt-font-dropdown-container", "");
    const realSelect = document.getElementById("quilt-font-real-select" + idSuffix);

    if (!selected || !realSelect) return;

    selected.addEventListener("click", function (e) {
      e.stopPropagation();
      document.querySelectorAll(".quilt-dropdown-container, [id^='quilt-font-dropdown-container']").forEach((d) => {
        if (d !== fontDropdown) d.classList.remove("active");
      });
      fontDropdown.classList.toggle("active");
    });

    options.forEach((option) => {
      option.addEventListener("click", function () {
        if (realSelect.disabled) return;
        const val = this.dataset.value;
        const img = this.dataset.image;
        realSelect.value = val;
        selected.innerHTML = `<div class="selected-font-item"><img src="${img}" alt="${val}"><span>${val}</span></div>`;
        fontDropdown.classList.remove("active");
        selected.classList.remove("field-error");
        
        const wrapper = fontDropdown.closest(".quilt-font-wrapper");
        if (wrapper) {
          const error = wrapper.querySelector(".quilt-font-error") || wrapper.querySelector("small");
          if (error) error.style.display = "none";
        }
      });
    });
  });

  document.addEventListener("click", function () {
    document.querySelectorAll(".quilt-dropdown-container, [id^='quilt-font-dropdown-container']").forEach((d) => d.classList.remove("active"));
  });
  document.addEventListener("click", function (e) {
    const button = e.target.closest(".quit_persintt") || e.target.closest('button[type="submit"]') || e.target.closest('.product-form__submit');
    if (!button) return;
    
    const form = button.closest("form");
    if (!form) return;
    
    let valid = true;
    
    const quiltColors = form.querySelectorAll('input[name="properties[Quilt Color]"]');
    if (quiltColors.length > 0) {
      let checked = false;
      quiltColors.forEach((radio) => { if (radio.checked) checked = true; });
      const colorError = form.querySelector(".quilt-color-error");
      if (!checked) {
        valid = false;
        if (colorError) colorError.style.display = "block";
      } else {
        if (colorError) colorError.style.display = "none";
      }
    }
    
    const isPersonalizedOff = form.querySelector('input[name="personalization_toggle"]:checked')?.value === 'off';
    if (isPersonalizedOff) {
      if (!valid) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return; 
    }
    
   const textInputs = form.querySelectorAll(
  '.product-custom-Phrase input[type="text"]'
);
    textInputs.forEach((input) => {
      if (input.disabled) return;
      const wrapper = input.closest(".product-custom-Phrase");
      if (!wrapper) return;
      const error = wrapper.querySelector(".quilt-font-error");
      if (input.value.trim() === "") {
        valid = false;
        input.classList.add("field-error");
        if (error) error.style.display = "block";
      } else {
        input.classList.remove("field-error");
        if (error) error.style.display = "none";
      }
    });
    
    const hiddenInputs = form.querySelectorAll(".real-select");
    hiddenInputs.forEach((input) => {
      if (input.disabled) return;
      const wrapper = input.closest(".product-custom-Phrase");
      if (!wrapper) return;
      const error = wrapper.querySelector(".quilt-font-error");
      const dropdown = wrapper.querySelector(".quilt-selected-option");
      if (input.value.trim() === "") {
        valid = false;
        if (dropdown) dropdown.classList.add("field-error");
        if (error) error.style.display = "block";
      } else {
        if (dropdown) dropdown.classList.remove("field-error");
        if (error) error.style.display = "none";
      }
    });
const backLogos = form.querySelectorAll(".back-logo");

backLogos.forEach((backLogo) => {
  const wrapper = backLogo.closest(".product-custom-Phrase");
  const error = wrapper?.querySelector(".quilt-font-error");

  if (backLogo.files.length === 0) {
    valid = false;
    if (error) error.style.display = "block";
  } else {
    if (error) error.style.display = "none";
  }
});
    
  form.querySelectorAll("[id^='quilt-font-real-select'], .quilt-font-real-select").forEach((fontSelect) => {
    if (fontSelect.disabled) return;

    const wrapper = fontSelect.closest(".quilt-font-wrapper");
    if (!wrapper) return;

    const fontUI = wrapper.querySelector(".quilt-font_select");
    const fontError =
        wrapper.querySelector(".logo-error-qutt") ||
        wrapper.querySelector(".quilt-font-error") ||
        wrapper.querySelector("small");

    if (fontSelect.value.trim() === "") {
        valid = false;

        if (fontUI) fontUI.classList.add("field-error");
        if (fontError) fontError.style.display = "block";
    } else {
        if (fontUI) fontUI.classList.remove("field-error");
        if (fontError) fontError.style.display = "none";
    }
});

    if (!valid) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, false);
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[name="properties[Quilt Color]"]')) {
      const form = e.target.closest("form");
      if (form) {
        const colorError = form.querySelector(".quilt-color-error");
        if (colorError) colorError.style.display = "none";
      }
    }
  });
document.addEventListener("input", function (e) {
  if (e.target.matches('.product-custom-Phrase input[type="text"]')) {
    const wrapper = e.target.closest(".product-custom-Phrase");
    if (!wrapper) return;

    const error = wrapper.querySelector(".quilt-font-error");

    if (e.target.value.trim() !== "") {
      e.target.classList.remove("field-error");
      if (error) error.style.display = "none";
    }
  }
});
});
document.addEventListener("DOMContentLoaded", function () {
    flatpickr("#baby-dob", {
        dateFormat: "m/d/Y",
        allowInput: true
    });
});




// Quilt Font Style /////
document.addEventListener('DOMContentLoaded', function () {
  function initFontDropdown(
    containerId,
    selectedId,
    optionsId,
    selectId
  ) {

    const container = document.getElementById(containerId);
    const selected = document.getElementById(selectedId);
    const options = document.getElementById(optionsId);
    const realSelect = document.getElementById(selectId);

    if (!container || !selected || !options || !realSelect) {
      return;
    }
    const fontOptions = options.querySelectorAll('.quilt-Tfont_option');
    selected.addEventListener('click', function (e) {
      e.stopPropagation();
      options.classList.toggle('show');
    });
    fontOptions.forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const value = this.dataset.value || '';
        const image = this.dataset.image || '';

        selected.innerHTML = `
          <img src="${image}"
               alt="${value}"
               style="margin-right:10px;">
          <span>${value}</span>
        `;

        realSelect.value = value;

        realSelect.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        options.classList.remove('show');
      });

    });
    document.addEventListener('click', function () {
      options.classList.remove('show');
    });

  }
  initFontDropdown(
    'quilt-font-dropdown-container1',
    'quilt-font-selected-option1',
    'quilt-font-dropdown-options1',
    'quilt-font-real-select1'
  );
  initFontDropdown(
    'quilt-font-dropdown-container2',
    'quilt-font-selected-option2',
    'quilt-font-dropdown-options2',
    'quilt-font-real-select2'
  );
});

// Quilt accordion /////
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.accordion-htt').forEach(function (header) {

    header.addEventListener('click', function (e) {

      e.preventDefault();
      e.stopPropagation();

      const accordion = this.closest('.accordion-stt');

      if (!accordion) return;

      const wasActive = accordion.classList.contains('active');

      document.querySelectorAll('.accordion-stt.active').forEach(function (item) {
        item.classList.remove('active');
      });

      if (!wasActive) {
        accordion.classList.add('active');
      }

    });

  });

});




// Quilt Variant selected option change price /////////////
document.addEventListener('DOMContentLoaded', function() {
  const radios = document.querySelectorAll('input[name="personalization_toggle"]');
  const customQuiltClass = document.querySelector('.product_cust_quilt');
  const messageDiv = document.querySelector('.show_mssgett');
  const hiddenField = document.getElementById('personall-field');
  const singleOptionSelector = document.querySelector('.single-option-selector');
  const masterSelect = document.querySelector('select.product-form__variants');
  const addToCartButton = document.querySelector('button[name="add"]');
  const addToCartText = addToCartButton ? addToCartButton.querySelector('span') : null;

  function updateShopifyVariant(variantName) {
    let targetText = variantName.trim().toLowerCase();
    let variantFound = false;
    if (singleOptionSelector) {
      for (let option of singleOptionSelector.options) {
        let optVal = option.value.trim().toLowerCase();
        if (optVal === targetText) {
          singleOptionSelector.value = option.value;
          singleOptionSelector.dispatchEvent(new Event('change', { bubbles: true }));
          variantFound = true;
          break;
        }
      }
    }
    if (masterSelect) {
      for (let option of masterSelect.options) {
        let masterOptText = option.text.trim().toLowerCase();
        if (masterOptText.includes(targetText)) {
          masterSelect.value = option.value;
          masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
          if (option.disabled || option.innerText.includes('sold out')) {
            if (addToCartButton) {
              addToCartButton.setAttribute('disabled', 'disabled');
              if (addToCartText) addToCartText.innerText = "Sold Out";
            }
          } else {
            if (addToCartButton) {
              addToCartButton.removeAttribute('disabled');
              if (addToCartText) addToCartText.innerText = "Add to Cart";
            }
          }
          break;
        }
      }
    }
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (productForm) {
      productForm.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  radios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.value === 'off') {
        if (customQuiltClass) customQuiltClass.style.display = 'none';
        if (messageDiv) messageDiv.style.display = 'block';
        updateShopifyVariant('Without Personalization Quilt');
      } else {
        if (customQuiltClass) customQuiltClass.style.display = 'block';
        if (messageDiv) messageDiv.style.display = 'none';
        updateShopifyVariant('abc');
      }
    });
  });
  setTimeout(function() {
    const checkedRadio = document.querySelector('input[name="personalization_toggle"]:checked');
    if (checkedRadio) {
      if (checkedRadio.value === 'off') {
        updateShopifyVariant('Without Personalization Quilt');
      } else {
        updateShopifyVariant('abc');
      }
    }
  }, 750); 
});



/****************************
FONT STYLE 1 VALIDATION
****************************/
document.addEventListener("DOMContentLoaded", function () {
    const dropdown = document.querySelector(".cuhp-dropdown");
    const selected = document.querySelector(".an_select");
    const options = document.querySelectorAll(".Tont_opth");
    const select = document.querySelector(".ftn-selected");
    const error = document.querySelector(".font-errors");
    const addToCart = document.querySelector('button[name="add"]');
    const noRadio = document.querySelector(".of_Personalization");
    if (!dropdown || !selected || !select) return;
    selected.addEventListener("click", function (e) {
        e.stopPropagation();
        dropdown.classList.toggle("active");
    });
    options.forEach(function (option) {

        option.addEventListener("click", function (e) {

            e.preventDefault();
            e.stopPropagation();

            const value = this.dataset.value;
            const image = this.dataset.image;

            selected.innerHTML = `
                <img src="${image}" style="height:30px;margin-right:10px;">
                <span>${value}</span>
            `;

            select.value = value;

            error.style.display = "none";
            selected.classList.remove("field-error");

            dropdown.classList.remove("active");

            select.dispatchEvent(
                new Event("change", { bubbles: true })
            );
        });
    });
    noRadio?.addEventListener("change", function () {

        if (this.checked) {

            select.value = "";

            error.style.display = "none";

            selected.classList.remove("field-error");
        }
    });
  addToCart?.addEventListener("click", function (e) {

    if (noRadio && noRadio.checked) {
        return true;
    }
    const fontWrapper = document.querySelector(".font-wr44");
    if (
        !fontWrapper ||
        window.getComputedStyle(fontWrapper).display === "none"
    ) {
        return true;
    }
    if (select.value === "") {
        e.preventDefault();
        error.style.display = "block";
        selected.classList.add("field-error");
        selected.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });

        return false;
    }
    
});
    document.addEventListener("click", function () {
        dropdown.classList.remove("active");
    });

});
document.addEventListener("DOMContentLoaded", function () {

    const patternSelect = document.querySelector('#SingleOptionSelector-0');
    const fontWrapper = document.querySelector('.font-wr44');

    function toggleFontStyle() {
        if (!patternSelect || !fontWrapper) return;

        if (patternSelect.value === 'Both') {
            fontWrapper.style.display = 'block';
        } else {
            fontWrapper.style.display = 'none';
            const select = document.querySelector('.ftn-selected');
            const selected = document.querySelector('.an_select');

            if (select) {
                select.value = '';
            }

            if (selected) {
                selected.innerHTML = '<span>Select an Option</span>';
                selected.classList.remove('field-error');
            }

            const error = document.querySelector('.font-errors');
            if (error) {
                error.style.display = 'none';
            }
        }
    }
    toggleFontStyle();
    patternSelect.addEventListener('change', toggleFontStyle);

});


document.querySelectorAll(".back-logo").forEach((input) => {
    const wrapper = input.closest(".product-custom-Phrase");
    const preview = wrapper.querySelector(".back-logo-preview");
    const error = wrapper.querySelector(".quilt-font-error");

    input.addEventListener("change", function (e) {
        error.style.display = "none";

        const file = e.target.files[0];
        if (!file) return;

        const img = new Image();

        img.onload = function () {
            if (img.width > 100 || img.height > 100) {
                input.value = "";
                preview.style.display = "none";
                error.textContent = "Image must be 100×100 pixels or smaller.";
                error.style.display = "block";
                return;
            }

            preview.src = URL.createObjectURL(file);
            preview.style.display = "block";
        };

        img.src = URL.createObjectURL(file);
    });
});


document.querySelectorAll(".quilt-font-real-select").forEach((fontSelect) => {
    fontSelect.addEventListener("change", function () {

        const wrapper = this.closest(".quilt-font-wrapper");
        if (!wrapper) return;

        const fontUI = wrapper.querySelector(".quilt-font_select");
        const fontError =
            wrapper.querySelector(".logo-error-qutt") ||
            wrapper.querySelector(".quilt-font-error") ||
            wrapper.querySelector("small");

        if (this.value.trim() !== "") {
            if (fontUI) fontUI.classList.remove("field-error");
            if (fontError) fontError.style.display = "none";
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".second-font-style").forEach(function (wrapper) {
    const selected = wrapper.querySelector(".second-font-selected");
    const options = wrapper.querySelector(".second-font-options");
    const realSelect = wrapper.querySelector(".second-font-real-select");
    const error = wrapper.querySelector(".second-font-error");
    if (!selected || !options || !realSelect) return;
    selected.addEventListener("click", function (e) {
      e.stopPropagation();
      document.querySelectorAll(".second-font-options").forEach(function (other) {
        if (other !== options) {
          other.classList.remove("show");
        }
      });
      options.classList.toggle("show");
    });
    options.querySelectorAll(".second-font-option").forEach(function (option) {
      option.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const value = this.dataset.value;
        const image = this.dataset.image;
        selected.innerHTML = `
          <img src="${image}" 
               alt="${value}"
               style="margin-right:10px;">
          <span>${value}</span>
        `;
        realSelect.value = value;
        realSelect.dispatchEvent(
          new Event("change", {
            bubbles: true
          })
        );
        selected.classList.remove("field-error");

        if (error) {
          error.style.display = "none";
        }
        options.classList.remove("show");
      });
    });
  });
  document.addEventListener("click", function () {
    document.querySelectorAll(".second-font-options").forEach(function (options) {
      options.classList.remove("show");
    });

  });
});

document.addEventListener("DOMContentLoaded", function () {
  const variantSelects = document.querySelectorAll(".single-option-selector");
  variantSelects.forEach(function (select) {
    function updateVariantProperty() {
      const wrapper = select.closest(".product-form__item, .selector-wrapper");
      if (!wrapper) return;
      const hiddenInput = wrapper.querySelector(".variant-property");
      if (hiddenInput) {
        hiddenInput.value = select.value;
      }
    }
    updateVariantProperty();
    select.addEventListener("change", function () {
      updateVariantProperty();
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const yesRadio = document.querySelector('.on_personal_quilt');
  const noRadio = document.querySelector('.of_Personal_quilt');
  const messageElement = document.getElementById('corner-embroidery-price-message');

  if (!yesRadio || !noRadio || !messageElement) return;

  noRadio.addEventListener('change', function () {
    if (this.checked) {
      messageElement.style.display = 'none';
    }
  });

  yesRadio.addEventListener('change', function () {
    if (this.checked) {
      messageElement.style.display = 'block';
    }
  });
});



// FIX: Keep actual Basket Color when Personalization is OFF
document.addEventListener("DOMContentLoaded", function () {
  const select = document.querySelector("#SingleOptionSelector-0");
  if (!select) return;
  const wrapper = select.closest(".product-form__item, .selector-wrapper");
  const propertyInput = wrapper
    ? wrapper.querySelector('.variant-property[name="properties[Basket Color]"]')
    : null;
  const label = wrapper
    ? wrapper.querySelector(".custom-ui-label")
    : null;
  function saveBasketColor() {
    if (!propertyInput) return;
    const selectedValue = select.value;
    const displayedValue = label ? label.textContent.trim() : "";
    if (
      selectedValue &&
      selectedValue !== "Without Personalization"
    ) {
      select.dataset.lastBasketColor = selectedValue;
    }
    const actualColor =
      select.dataset.lastBasketColor ||
      (displayedValue &&
       displayedValue !== "Without Personalization" &&
       displayedValue !== "Select an Option"
        ? displayedValue
        : "");

    if (actualColor) {
      propertyInput.value = actualColor;
    }
  }
  select.addEventListener("change", saveBasketColor);
  saveBasketColor();
});